import React, { Component } from "react";
import { withTheme, withStyles } from "@material-ui/core/styles";
import SvgIcon from "@material-ui/core/SvgIcon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import * as d3 from "d3";

const styles = (theme) => ({
  node: {
    backgroundColor: "red",
    border: "2px solid",
  },
  tooltip: {
    // position: "absolute",
    // textAlign: "center",
    // width: "100px",
    // height: "10px",
    // padding: "8px",
    // font: "10px sans-serif",
    background: "#ffff99",
    // border: "solid 1px #aaa",
    // borderRadius: "8px",
    // pointerEvents: "none",
    // zIndex:1000,
  },
  draggableTools: {
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
  },
  draggable: {
    backgroundColor: "transparent",
    margin: theme.spacing(1),
    padding: 0,
    border: 0,
  },
  contextMenuTitleWrapper: {
    display: "flex",
    margin: theme.spacing(1),
  },
  contextMenuTitle: {
    marginLeft: theme.spacing(1),
  },
});
const TAXONOMY = "taxonomy";
const TEAM = "team";
const TOPIC = "topic";

const TOPIC_ICON =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";
const TOPIC_ICON_PLUS =
  "M18,14H20V17H23V19H20V22H18V19H15V17H18V14M12,3C16.42,3 20,4.79 20,7C20,9.21 16.42,11 12,11C7.58,11 4,9.21 4,7C4,4.79 7.58,3 12,3M4,9C4,11.21 7.58,13 12,13C16.42,13 20,11.21 20,9V9L20,12.08L19,12C16.41,12 14.2,13.64 13.36,15.94L12,16C7.58,16 4,14.21 4,12V9M4,14C4,16.21 7.58,18 12,18H13C13,19.05 13.27,20.04 13.75,20.9L12,21C7.58,21 4,19.21 4,17V14Z";
const TEAM_ICON =
  "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z";
const TEAM_ICON_PLUS =
  "M19 17V19H7V17S7 13 13 13 19 17 19 17M16 8A3 3 0 1 0 13 11A3 3 0 0 0 16 8M19.2 13.06A5.6 5.6 0 0 1 21 17V19H24V17S24 13.55 19.2 13.06M18 5A2.91 2.91 0 0 0 17.11 5.14A5 5 0 0 1 17.11 10.86A2.91 2.91 0 0 0 18 11A3 3 0 0 0 18 5M8 10H5V7H3V10H0V12H3V15H5V12H8Z";
const TAXONOMY_ICON =
  "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"; //M18,14V10H16V14H12V16H16V20H18V16H22V14
const TAXONOMY_ICON_PLUS =
  "M10,4L12,6H20A2,2 0 0,1 22,8V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M15,9V12H12V14H15V17H17V14H20V12H17V9H15Z";
const DEFAULT_ICON = "M18,14V10H16V14H12V16H16V20H18V16H22V14";
const PLUS_ICON =
  "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z";
  // "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z";
const MINUS_ICON =
  "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M17,11V13H7V11H17Z";
const DEFAULT_COLOUR = "black";
const ORGANIZATION_ICON =
  "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z";

export class TreeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoDiv: null,
      landscapeDepthAdjust: 320,
      portraitDepthAdjust: 150,
      portraitWidthAdjust: 150,
      charWidth: `${this.props.theme.typography.pxToRem(15)}`,
      topicColourTheme: `${this.props.theme.palette.primary.dark}`,
      teamColourTheme: `${this.props.theme.palette.secondary.dark}`,
      taxonomyColourTheme: `${this.props.theme.palette.primary.light}`,
      root: null,
      treemap: null,
      treeData: null,
      duration: 100,
      clickDistance: 28,
      draggingNode: null,
      dragTarget: null,
      dragOrigin: null,
      dropTarget: null,
      isDragging: false,
      sidebarOpen: false,
      // toolsData: [
      //   { id: "-1", type: TAXONOMY, name: "Taxonomy", icon: TAXONOMY_ICON },
      //   { id: "-1", type: TEAM, name: "Team", icon: TEAM_ICON },
      //   { id: "-1", type: TOPIC, name: "Topic", icon: TOPIC_ICON },
      // ],
      treeBuilt: false,
      contextAnchorEl: null,
      contextData: null,
      contextOpen: false,
      myContextMenu: [
        {
          title: "Header",
        },
        {
          title: "Normal item",
          action: function() {},
        },
        {
          divider: true,
        },
        {
          title: "Last item",
          action: function() {},
        },
      ],
    };
    this.update = this.update.bind(this);
    this.removeLinksForDragged = this.removeLinksForDragged.bind(this);
    this.addTargetCircle = this.addTargetCircle.bind(this);
    this.toggleChildren = this.toggleChildren.bind(this);
    this.wrap = this.wrap.bind(this);
    this.recalculatePositions = this.recalculatePositions.bind(this);
    this.zoomed = this.zoomed.bind(this);
    this.labelMouseover = this.labelMouseover.bind(this);
    this.labelMousemove = this.labelMousemove.bind(this);
    this.labelMouseout = this.labelMouseout.bind(this);
    this.getUpdatedTreeState = this.getUpdatedTreeState.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    (this.state.treemap === null ||
      this.props.landscape !== prevProps.landscape) && 
      this.buildChart(true);

    if (
      this.props.height !== prevProps.height ||
      this.props.width !== prevProps.width
    ) {
      if (this.props.height > 0 && this.props.width > 0) {
        d3.select("#chart.tree svg")
          .attr("height", this.props.height)
          .attr("width", this.props.width);
      }
    }
    if (
      (this.props.data !== null && this.props.data !== prevProps.data) ||
      this.props.landscape !== prevProps.landscape
    ) {
      var root = d3.hierarchy(this.props.data, function(d) {
        return d.children;
      });
      this.setState({ root: root });
    }
    if (prevProps.data !== null) {
      if (
        this.props.data.children !== prevProps.data.children ||
        this.props.data._children !== prevProps.data._children
      ) {
        var root = d3.hierarchy(this.props.data, function(d) {
          return d.children;
        });
        this.setState({ root: root });
      }
    }
    if (this.props.setLevel === true && this.state.treeBuilt === true) {
      // console.log("Setting level");
      this.setLevel(this.state.root);
      typeof this.props.onSetLevel === "function" && this.props.onSetLevel();
    }
    if (this.props.setExpanded === true && this.state.treeBuilt === true) {
      this.setLevel(this.state.root);
      typeof this.props.onSetExpanded === "function" &&
        this.props.onSetExpanded();
    }

    if (
      this.props.showTeam !== prevProps.showTeam ||
      this.props.showTopic !== prevProps.showTopic
    ) {
      this.update(this.state.root);
    }
    if (this.state.root !== prevState.root && this.state.root !== null) {
      this.clearCurrentTree(); //needed when switching to and from landscape
      // only reset the zoom/pan if the root has actually changed
      this.buildChart(
        prevState.root === null ||
          this.state.root.data.id !== prevState.root.data.id
      );
      var treeData = this.state.treemap(this.state.root);
      this.setState({ treeData: treeData });
    }
    if (
      this.state.treeData !== prevState.treeData &&
      this.state.treeData !== null
    ) {
      // this.update(this.state.root);
      this.setLevel(this.state.root);
    }

    this.props.isDragging !== prevProps.isDragging &&
      this.setState({ isDragging: this.props.isDragging });
    this.props.draggingNode !== prevProps.draggingNode &&
      this.setState({ draggingNode: this.props.draggingNode });
    this.props.dragOrigin !== prevProps.dragOrigin &&
      this.setState({ dragOrigin: this.props.dragOrigin });
    this.props.dragTarget !== prevProps.dragTarget &&
      this.setState({ dragTarget: this.props.dragTarget });
    if (
      this.state.draggingNode !== prevState.draggingNode &&
      this.state.draggingNode !== null
    ) {
      // console.log("removing links for dragging...")
      this.removeLinksForDragged();
      // console.log("removed links for dragging")
    }
    if (this.state.dragTarget !== prevState.dragTarget) {
      if (this.state.dragTarget !== null && this.state.isDragging) {
        // console.log("adding target circle...")
        d3.selectAll("circle.target").style("fill-opacity", 0);
        this.addTargetCircle();
        // console.log("added target circle")
      } else {
        // console.log("removing target circle...")
        d3.selectAll("circle.target").style("fill-opacity", 0);
        // console.log("removed target circle")
      }
    }
    // console.log("skipped target circles...")
    if (
      this.props.selectedNodeData !== prevProps.selectedNodeData &&
      this.props.selectedNodeData !== null
    ) {
      // A node has been edited and needs its value updating
      var textNodes = d3.selectAll("text.name");
      var target = textNodes.filter(
        function(d, i) {
          if (
            d.data.id == this.props.selectedNodeData.id &&
            d.data.type == this.props.selectedNodeData.type
          ) {
            d.data.name = this.props.selectedNodeData.name;
            if (d.data.type === TEAM && 
              d.data.id === this.props.selectedNodeData.id &&
              d.data.taxonomyId === this.props.selectedNodeData.taxonomyId) {
              d.data.object = this.props.selectedNodeData.object;
            }
            return true;
          }
          return false;
        }.bind(this)
      );
      target.text(this.getScaledText(this.props.selectedNodeData.name));

      d3.selectAll("text.roleSummary")
        .filter(
          function(d, i) {
            if (
              d.data.id == this.props.selectedNodeData.id &&
              d.data.type == this.props.selectedNodeData.type
            ) {
              return true;
            }
            return false;
          }.bind(this)
        )
        .text(this.roleSummary);

      //now update nodes for the same team/topic of the same name...
      var targetAll = textNodes.filter(
        function(d, i) {
          if (
            d.data.type == this.props.selectedNodeData.type &&
            d.data.object &&
            d.data.object[d.data.type + "Id"] ===
              this.props.selectedNodeData.object[d.data.type + "Id"]
          ) {
            d.data.name = this.props.selectedNodeData.name; //update the data that has changed
            return true;
          }
          return false;
        }.bind(this)
      );
      targetAll.text(this.getScaledText(this.props.selectedNodeData.name));
    }
    // console.log("finished componentDidUpdate...")
  }

  buildChart(resetZoomAndPan) {
    let startTime = new Date();
    const { classes } = this.props;
    this.recalculatePositions();
    if (resetZoomAndPan) {
      let svg = d3
        .select("#chart")
        .append("svg")
        .attr("height", this.props.height)
        .attr("width", this.props.width);
      d3.select("#chart svg.tree").remove();
      svg.classed("tree", true);
      let chart = svg.append("g").classed("chart", true);

      const x = this.props.landscape ? 180 : this.props.width / 2;
      const y = this.props.landscape ? this.props.height / 2 : 60;
      const scale = 1; //0.75 / Math.max(width / fullWidth, height / fullHeight)
      let transform = d3.zoomIdentity.translate(x, y).scale(scale);
      let zoom = d3
        .zoom()
        .extent([[0, 0], [this.props.width, this.props.height]])
        .scaleExtent([0.5, 4])
        .on("zoom", this.zoomed);

      svg.call(zoom.transform, transform).call(zoom);

      this.setState({ zoom: zoom });

      svg
        .on(
          "click",
          function(d) {
            if (d3.event.defaultPrevented) return;
            this.props.chartClick();
          }.bind(this)
        )
        .on(
          "contextmenu",
          function(d) {
            d3.event.preventDefault();
          }.bind(this)
        );

      var tooltip = svg.append("g").attr("class", classes.tooltip);

      // tooltip.append("rect")
      //   .attr("fill", this.state.topicColourTheme)
      //   .attr("height", "24")
      //   .attr("width", "240")

      this.setState({ infoDiv: tooltip });
      console.log("Finished Chart build:" + (new Date() - startTime) )
    }
  }
  recalculatePositions() {
    let nodeSize = this.props.landscape ? [60, 60] : [200, 40];
    var treemap = d3.tree().nodeSize(nodeSize);
    // .size([this.props.height, this.props.width])
    this.setState({ treemap: treemap });
  }
  clearCurrentTree() {
    d3.selectAll("path.link").remove();
    d3.selectAll("g.node").remove();
    d3.selectAll("text").remove();
  }

  removeLinksForDragged() {
    if (this.state.draggingNode.data) {
      //only deal with real nodes not dragged toolbar items

      //remove the path linking it to its parent
      d3.selectAll("path.link")
        .filter(
          function(d, i) {
            if (d.data.id === this.state.draggingNode.data.id) {
              return true;
            }
            return false;
          }.bind(this)
        )
        .remove();

      var draggedTree = this.state.treemap(this.state.draggingNode);
      var tmp = draggedTree.descendants().slice(1)

      var links = d3
        .select("#chart svg.tree g.chart")
        .selectAll("path.link")
        .data(draggedTree.descendants().slice(1), function(d) {
          return d.data.object ? d.data.object.attachedId : d.data.id;
        });
      links.remove();
    }
  }

  addTargetCircle() {
    var treeIcons = d3.selectAll("g.node");
    var target = treeIcons.filter(
      function(d, i) {
        if (d.data.id == this.state.dragTarget.data.id) {
          return true;
        }
        return false;
      }.bind(this)
    );

    var sel = target.select("circle.target");
    sel.style("fill-opacity", 0.4);
  }
  toggleChildren(d) {
    if (d.children) {
      d._children = d.children;
      d.children = null;
      d._children.length > 0 && this.update(d);
    } else {
      d.children = d._children;
      d._children = null;
      if (d.children) {
        // only expand one level, hide all children of children
        d.children.forEach((c) => {
          if (c.children) {
            c._children = c.children;
            c.children = null;
          }
        });
        d.children.length > 0 && this.update(d);
      }
    }
    //if we have an update function to record tree state use it
    typeof this.props.updateTreeState === "function" && 
      this.props.updateTreeState(d.children ? this.getUpdatedTreeState(d) : this.props.treeState.filter(e => e !== d.data.id))
  }
  getUpdatedTreeState(d) {
    let nodesToAdd = [].concat(d.data.parentList).concat([d.data.id])
    let newNodes = nodesToAdd.filter((n) => this.props.treeState.indexOf(n) === -1)
    return this.props.treeState.concat(newNodes)
  }
  setLevel(node) {
    //collapse children below node
    node.children &&
      node.children.forEach(
        function(d) {
          if (this.props.setLevel === true) {
            if (d.children) {
              d._children = d.children;
              d.children = null;
            }
          } else if (this.props.setExpanded === true) {
            if (d._children) {
              d.children = d._children;
              d._children = null;
            }
          } else if (this.props.setLevel === false && d.children && this.props.treeState.length > 0) {
             if (this.props.treeState.indexOf(d.data.id) === -1) {
              d._children = d.children;
              d.children = null;
             } else {
               //it's selected but we only want to show it's first level of children
               d.children.filter(c => this.props.treeState.indexOf(c.data.id) === -1).forEach((c) => {
                if (c.children) {
                  c._children = c.children;
                  c.children = null;
                }
              });
             }
          }
        }.bind(this)
      );
    this.recalculatePositions();
    this.update(node);
  }

  roleSummary(d) {
    let text = "Roles: ";
    let myObject = d.data.object;
    let allRoles = true;
    Object.keys(myObject).map(function(key, index) {
      typeof myObject[key] === "boolean" &&
        (myObject[key] === true
          ? (text += key.substring(0, 1) + " ")
          : (allRoles = false));
    });
    !allRoles && text.trim().endsWith(":") && (text = "Roles: Search only");
    let classif = d.data.object.classification
      ? " (" + d.data.object.classification + ") "
      : "";
    return allRoles ? "Roles: All" + classif : text + classif;
  }

  zoomed() {
    let selection = d3.select("#chart svg.tree g.chart");
    let transform = d3.event.transform;
    const x = this.props.landscape ? 60 : this.props.width / 2;
    const y = this.props.landscape ? this.props.height / 2 : 60;
    selection.attr("transform", transform);
  }
  // Creates a curved (diagonal) path from parent to the child nodes
  diagonal(s, d) {
    var path = this.props.landscape
      ? `M ${s.y} ${s.x}
              C ${(s.y + d.y) / 2} ${s.x},
                ${(s.y + d.y) / 2} ${d.x},
                ${d.y} ${d.x}`
      : `M ${s.x} ${s.y}
              C ${s.x} ${(s.y + d.y) / 2}
                ${d.x} ${(s.y + d.y) / 2}
                ${d.x} ${d.y}`;
    return path;
  }

  wrap(text, width) {
    text.each(function() {
      var text = d3.select(this),
        words = text
          .text()
          .split(/\s+/)
          .reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 0.9, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = 0, //parseFloat(text.attr("dy")),
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", x)
          .attr("y", y)
          .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            // .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .attr("dy", lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  }
  getScaledText(name) {
    const len = this.props.landscape ? 28 : 15;
    let text =
      name && name !== null
        ? name.length > len
          ? name.substring(0, len) + "..."
          : name
        : "";
    return text;
  }
  labelMouseover(d) {
    const len = this.props.landscape ? 28 : 15;
    if (d.data.name !== null) {
      if (d.data.name.length > len) {
        const txtBox = this.state.infoDiv
          .append("text")
          .text(d.data.name)
          .attr("dx", 22)
          .attr("dy", 8);

        let bb = txtBox.node().getBBox();
        this.state.infoDiv
          .append("rect")
          .attr("x", bb.x - 10)
          .attr("y", bb.y - 5)
          .attr("width", bb.width + 20)
          .attr("height", bb.height + 10)
          .attr("fill", "white")
          .attr("stroke", "#dddddd")
          .attr("stroke-width", "1");
        txtBox.raise();
      }
    }
  }

  labelMousemove(d) {
    let transform = d3
      .zoomTransform(this.state.infoDiv.node())
      .translate(
        this.props.landscape ? d.y : d.x,
        this.props.landscape ? d.x : d.y
      );
    this.state.infoDiv.attr("transform", transform);
  }

  labelMouseout() {
    this.state.infoDiv
      .selectAll("text")
      .remove()
      .transition()
      .duration(300)
      .style("opacity", 1e-6);
    this.state.infoDiv
      .selectAll("rect")
      .remove()
      .transition()
      .duration(300)
      .style("opacity", 1e-6);
  }
  preventContextMenuOnModal = () => {
    let pop = d3.select("div#context-menu");
    pop.on(
      "contextmenu",
      function(d) {
        d3.event.preventDefault();
        this.setState({
          contextOpen: false,
        });
      }.bind(this)
    );
  };
  moveDraggedNodeToTarget(source, dragged) {
    //updates the data for a specific node
    // let start = this.state.dragOrigin
    // let startChildren = start.data.children.filter(d => d.id !== dragged.data.id)
    //remove all the children from the source
    let sourceNode = d3.select("g.node#" + this.state.dragOrigin.data.type + "-" + this.state.dragOrigin.data.id)
    sourceNode.selectAll("g.node").remove();
    // sourceNode.selectAll("g.node").data(startChildren);

    // var nodeEnter = sourceNode
    //   .enter()
    //   .append("g")
    //   .attr("class", "node")
    //   .attr(
    //     "transform",
    //     function(d) {
    //       return this.props.landscape
    //         ? "translate(" + source.y0 + "," + source.x0 + ")"
    //         : "translate(" + source.x0 + 10 + "," + source.y0 + ")";
    //     }.bind(this)
    //   )
    //   .attr("id", function(d) {
    //     return d.data.type + "-" + d.data.id;
    //   });
  }
  update(source) {
    const { classes, theme } = this.props;
    var i = 0;
    // Assigns the x and y position for the nodes
    this.state.treemap(this.state.root);
    // Compute the new tree layout.
    var nodes = this.state.treeData.descendants(),
      links = this.state.treeData.descendants().slice(1);

    nodes.forEach(
      function(d) {
        this.props.landscape
          ? (d.y = d.depth * this.state.landscapeDepthAdjust)
          : (d.y = d.depth * this.state.portraitDepthAdjust);
        d.x0 = d.x;
        d.y0 = d.y;
      }.bind(this)
    );

    // Update the nodes...
    var node = d3
      .select("#chart svg.tree g.chart")
      .selectAll("g.node")
      .data(
        nodes.filter(
          function(d, i) {
            const type = d.data.type;
            return (type === TEAM && this.props.showTeam) ||
              (type === TOPIC && this.props.showTopic) ||
              type === TAXONOMY
              ? true
              : false;
          }.bind(this)
        ),
        function(d) {
          let id2use = d.data.type === TAXONOMY ? d.data.id : d.data.object.attachedId
          return id2use || (d.id = ++i);
        }
      );

    // Enter any new nodes at the parent's previous position.
    var nodeEnter = node
      .enter()
      .append("g")
      .attr("class", "node")
      .attr(
        "transform",
        function(d) {
          return this.props.landscape
            ? "translate(" + source.y0 + "," + source.x0 + ")"
            : "translate(" + source.x0 + 10 + "," + source.y0 + ")";
        }.bind(this)
      )
      .attr("id", function(d) {
        let id2use = d.data.type === TAXONOMY ? d.data.id : d.data.object.attachedId
        return d.data.type + "-" + id2use;
      });

    nodeEnter
      .on(
        "mouseover",
        function(d) {
          if (this.state.isDragging) {
            d3.select(d3.event.target).style("cursor", "move");
            var dragged = this.state.draggingNode;
            const id = d.data ? d.data.id : d.id;
            const type = d.data ? d.data.type : d.type;
            const dragId = dragged.data ? dragged.data.id : dragged.id;
            const dragType = dragged.data ? dragged.data.type : dragged.type;
            if (dragId !== id || dragType !== TAXONOMY) {
              if (d.data.type === TAXONOMY) {
                this.props.setDragTarget(d);
                this.props.setAnchorEl(d3.event.target);
              }
            }
          } else {
            d3.select(d3.event.target).style("cursor", "pointer");
            this.labelMouseover(d);
          }
        }.bind(this)
      )
      .on(
        "mouseout",
        function(d) {
          d3.select(d3.event.target).style("cursor", "default");
          if (d.data.type === TAXONOMY) {
            var dragged = this.state.draggingNode;
            if (dragged) {
              if (dragged !== d && dragged.hasOwnProperty("data")) {
                this.props.setDragTarget(null);
              }
            }
          }
          this.labelMouseout();
        }.bind(this)
      )
      .on(
        "mousemove",
        function(d) {
          this.labelMousemove(d);
        }.bind(this)
      )
      .on(
        "dragover",
        function(d) {
          //listened for by d3 dnd but initiated by native dnd when a new item is dragged on to the tree
          //(mouseover event above is triggered by dragging an existing node)
          if (this.state.isDragging) {
            var dragged = this.state.draggingNode;
            if (dragged.id !== d.data.id) {
              if (
                this.props.dragTarget === null ||
                this.props.dragTarget.data.id !== d.data.id
              ) {
                if (d.data.type === TAXONOMY) {
                  this.props.setDragTarget(d);
                  this.props.setAnchorEl(d3.event.target);
                }
              }
            }
          } else {
            this.labelMouseover(d);
          }
        }.bind(this)
      )
      .on(
        "dragleave",
        function(d) {
          //listened for by d3 dnd but initiated by native dnd when a new item is dragged and leaves the target
          //(mouseout event above is triggered by dragging an existing node off the target)
          if (d.data.type === TAXONOMY) {
            this.props.setDragTarget(null);
            // this.props.setAnchorEl(null)
          }
          this.labelMouseout();
        }.bind(this)
      )
      .transition()
      .duration(0)
      .attr(
        "transform",
        function(d) {
          const x = -8;
          const y = 0;
          return "translate(" + x + "," + y + ")";
        }.bind(this)
      );

    // Add labels for the nodes
    let txt = nodeEnter
      .append("text")
      .attr("class", "name")
      .attr(
        "x",
        function(d) {
          const pos = this.props.landscape
            ? d.children || d._children
              ? -55
              : 15
            : 15;
          return pos;
        }.bind(this)
      )
      .attr(
        "y",
        function(d) {
          const pos = this.props.landscape ? 6 : 10;
          return pos;
        }.bind(this)
      )
      .attr(
        "text-anchor",
        function(d) {
          const pos = this.props.landscape
            ? d.children || d._children
              ? "end"
              : "start"
            : "start";
          return pos;
        }.bind(this)
      )
      .attr("font-size", this.state.charWidth)
      .text(
        function(d) {
          return this.getScaledText(d.data.name);
        }.bind(this)
      )
      // .call( this.wrap,this.props.landscape ? 200 : 180)
      .on(
        "click",
        function(d) {
          if (d3.event.defaultPrevented) return;
          d3.event.stopPropagation();
          this.props.nodeClick(d);
        }.bind(this)
      );

    //Add circles to be used as target idenitifiers for drag and drop
    nodeEnter
      .append("circle")
      .attr("class", "target")
      .attr("r", 20)
      .attr("aria-label", function(d) {
        return d.data.type + " " + d.data.name;
      })
      .style("fill-opacity", 0)
      .style("fill", function(d) {
        return "lightsteelblue";
      })
      .on(
        "click",
        function(d) {
          if (d3.event.defaultPrevented) return;
          d3.event.stopPropagation();
          // this.props.setAnchorEl(d3.event.target)
          this.props.nodeClick(d);
        }.bind(this)
      )
      .on(
        "contextmenu",
        function(d) {
          d3.event.preventDefault();
          d3.event.stopPropagation();
          this.setState({
            contextAnchorEl: d3.event.target,
            contextData: d,
            contextOpen: true,
          });
        }.bind(this)
      )
      .transition()
      .duration(0)
      .attr(
        "transform",
        function(d) {
          return this.props.landscape ? "translate(-8,0)" : "translate(0,6)";
        }.bind(this)
      );

    // UPDATE
    var nodeUpdate = nodeEnter.merge(node);

    // Transition to the proper position for the node
    nodeUpdate
      .transition()
      // .duration(this.state.duration)
      .duration(
        function(d) {
          return source === d ? this.state.duration : this.state.duration / 2;
        }.bind(this)
      )
      .attr(
        "transform",
        function(d) {
          return this.props.landscape
            ? "translate(" + d.y + "," + d.x + ")"
            : "translate(" + d.x + "," + d.y + ")";
        }.bind(this)
      );

    nodeEnter
      .append("path")
      .attr(
        "fill",
        function(d) {
          var type = d.data.type;
          return type === TAXONOMY
            ? this.state.taxonomyColourTheme
            : type === TOPIC
              ? this.state.topicColourTheme
              : type === TEAM
                ? this.state.teamColourTheme
                : DEFAULT_COLOUR;
        }.bind(this)
      )
      .attr(
        "d",
        function(d) {
          var type = d.data.type;
          return type === TAXONOMY
            ? TAXONOMY_ICON
            : type === TOPIC
              ? TOPIC_ICON
              : type === TEAM
                ? TEAM_ICON
                : null;
        }.bind(this)
      )
      .attr("id", function(d) {
        return d.data.type + "-target-" + d.data.id;
      })
      .attr("aria-label", function(d) {
        return d.data.type + " " + d.data.name;
      })
      .classed("icon", true)
      .transition()
      .duration(0)
      .attr(
        "transform",
        function(d) {
          const x = this.props.landscape ? -20 : -12;
          const y = this.props.landscape ? -12 : -6;
          return "translate(" + x + "," + y + ")";
        }.bind(this)
      )
      .attr("id", function(d) {
        return d.data.type + "-target-" + d.data.id;
      });
    // .attr("aria-label", function(d) {
    //   return d.data.type + " " + d.data.name;
    // });

    nodeEnter
      .filter(function(d, i) {
        return d.data.type === TEAM ? true : false;
      })
      .append("text")
      .attr("class", "roleSummary")
      .attr(
        "dy",
        function(d) {
          return this.props.landscape ? "1.7em" : "2em";
        }.bind(this)
      )
      .attr("dx", "-1.7em")
      .attr("text-anchor", "start")
      .attr("font-size", "0.7em")
      .text(this.roleSummary);

    let expandable = nodeEnter.filter(function(d, i) {
      let include = false;
      if (d.data.type === TAXONOMY) {
        if (d.data.children) {
          include = d.data.children.length > 0 ? true : false;
        } else if (d.data._children) {
          include = d.data._children.length > 0 ? true : false;
        }
      }
      return include;
    });

    expandable
      .append("path")
      .attr("fill", this.state.taxonomyColourTheme)
      .attr("class", "expand")
      .attr("d", function(d) {
        return d.children ? MINUS_ICON : PLUS_ICON;
      })
      .transition()
      .duration(0)
      .attr(
        "transform",
        function(d) {
          const x = this.props.landscape === true ? -50 : -45;
          const y = this.props.landscape === true ? -12 : -6;
          return "translate(" + x + "," + y + ")";
        }.bind(this)
      );

    let rect = expandable
      .append("rect")
      .attr("fill", this.state.taxonomyColourTheme)
      .attr("opacity", "0")
      .attr("class", "expand")
      .attr("height", "24")
      .attr("width", "24")
      .attr("aria-label", function(d) {
        return "expand " + d.data.name;
      })
      .on(
        "click",
        function(d) {
          if (d3.event.defaultPrevented) {
            return;
          }
          d3.event.stopPropagation();
          d.data.type === TAXONOMY && this.toggleChildren(d);
          // this.props.nodeClick(d)
        }.bind(this)
      )
      .on("mouseover", function() {
        d3.select(d3.event.target).style("cursor", "pointer");
      })
      .on("mouseout", function() {
        d3.select(d3.event.target).style("cursor", "default");
      });
    rect
      .transition()
      .duration(0)
      .attr(
        "transform",
        function(d) {
          const x = -50;
          const y = -12;
          return "translate(" + x + "," + y + ")";
        }.bind(this)
      );

    // rect.raise();

    nodeUpdate
      .selectAll("path.expand")
      .attr("d", function(d) {
        return d.children ? MINUS_ICON : PLUS_ICON;
      })
      .raise();

    nodeUpdate.selectAll("path.icon").lower();

    nodeUpdate.selectAll("circle.target").raise();

    nodeUpdate.selectAll("rect.expand").raise();

    // Remove any exiting nodes
    var nodeExit = node
      .exit()
      .transition()
      .duration(this.state.duration)
      .attr(
        "transform",
        function(d) {
          return this.props.landscape
            ? "translate(" + source.y0 + "," + source.x0 + ")"
            : "translate(" + source.x0 + "," + source.y0 + ")";
        }.bind(this)
      )
      .remove();

    // On exit reduce the node circles size to 0
    nodeExit.select("circle").attr("r", 1e-6);

    // On exit reduce the opacity of text labels
    nodeExit.select("text").style("fill-opacity", 1e-6);

    // Update the links...
    d3.select("#chart svg.tree g.chart")
      .selectAll("path.link")
      .remove();
    var link = d3
      .select("#chart svg.tree g.chart")
      .selectAll("path.link")
      .data(
        links.filter(
          function(d, i) {
            const type = d.data.type;
            return (type === TEAM && this.props.showTeam) ||
              (type === TOPIC && this.props.showTopic) ||
              type === TAXONOMY
              ? true
              : false;
          }.bind(this)
        ),
        function(d) {
          let id2use = d.data.type === TAXONOMY ? d.data.id : d.data.object.attachedId
          return id2use || (d.id = ++i);
        }
      );

    // Enter any new links at the parent's previous position.
    var linkEnter = link
      .enter()
      .insert("path", "g")
      .attr("class", "link")
      .attr("fill", "none")
      .attr("stroke", "lightsteelblue")
      .attr(
        "d",
        function(d) {
          var o = { x: source.x0, y: source.y0 };
          return this.diagonal(o, o);
        }.bind(this)
      );

    // UPDATE
    var linkUpdate = linkEnter.merge(link);
    linkUpdate.lower();

    // Transition back to the parent element position
    linkUpdate
      .transition()
      .duration(
        function(d) {
          return source === d ? this.state.duration : 0;
        }.bind(this)
      )
      .attr(
        "d",
        function(d) {
          return this.diagonal(d, d.parent);
        }.bind(this)
      );

    // Remove any exiting links
    link
      .exit()
      .transition()
      .duration(this.state.duration)
      .attr(
        "d",
        function(d) {
          var o = { x: source.x, y: source.y };
          return this.diagonal(o, o);
        }.bind(this)
      )
      .remove();

    if (this.props.dragDropEnabled) {
      d3.selectAll("g.node").call(
        d3
          .drag()
          .clickDistance(this.state.clickDistance)
          .on(
            "start",
            function(d) {
              d3.event.sourceEvent.stopPropagation();
              d.startX = d3.event.sourceEvent.clientX;
              d.startY = d3.event.sourceEvent.clientY;
            }.bind(this)
          )
          .on(
            "drag",
            function(d) {
              var dStartX = d.startX - d3.event.sourceEvent.clientX,
                dStartY = d.startY - d3.event.sourceEvent.clientY;
              if (dStartX * dStartX + dStartY * dStartY > 16) {
                this.setState({
                  isDragging: true,
                  draggingNode: d,
                  dragOrigin: d.parent,
                });
                //hide any children of the object being dragged
                if (d.children) {
                  let childNodes = this.getChildren(d.children)
                  childNodes.forEach(c => {
                    let id2use = c.data.type === TAXONOMY ? c.data.id : c.data.object.attachedId
                    d3.select("g.node#" + c.data.type + "-" + id2use).remove()
                  })
                } 
                let id2use = d.data.type === TAXONOMY ? d.data.id : d.data.object.attachedId
                var dragged = d3.select("g.node#" + d.data.type + "-" + id2use);
                if (this.props.landscape) {
                  d.x0 += d3.event.dy;
                  d.y0 += d3.event.dx;
                } else {
                  d.x0 += d3.event.dx;
                  d.y0 += d3.event.dy;
                }
                dragged.lower();
                var dr = dragged._groups[0];
                this.props.landscape
                  ? d3
                      .select(dr[0])
                      .transition()
                      .duration(0)
                      .attr("transform", "translate(" + d.y0 + "," + d.x0 + ")")
                  : d3
                      .select(dr[0])
                      .transition()
                      .duration(0)
                      .attr(
                        "transform",
                        "translate(" + d.x0 + "," + d.y0 + ")"
                      );
              }
            }.bind(this)
          )
          .on(
            "end",
            function(d) {
              this.setState({ isDragging: false });
              d3.selectAll("circle.target").style("fill-opacity", 0);
              if (this.state.draggingNode !== null) {
                if (this.state.dragTarget !== null) {
                  //find the dragged node and remove from DOM
                  let id2use = d.data.type === TAXONOMY ? d.data.id : d.data.object.attachedId
                  var dragged = d3.select("g.node#" + d.data.type + "-" + id2use);
                  var dr = dragged._groups[0];
                  this.props.dragDropAction(d, this.state.dragTarget);
                  d3.select("g.node#" + this.state.dragOrigin.data.type + "-" + this.state.dragOrigin.data.id).remove();
                } else {
                  //we haven't dropped on a valid target so redraw
                  this.update(d);
                  this.props.setDragTarget(null);
                  this.setState({
                    isDragging: false,
                    draggingNode: null,
                    dragOrigin: null,
                    // dragTarget: null,
                  });
                }
              }
            }.bind(this)
          )
      );
    }
    !this.state.treeBuilt && this.setState({ treeBuilt: true });
  }
  getChildren = (children) => {
    let childArr = []
    children.forEach(c => {
      childArr.push(c)
      if (Array.isArray(c.children) && c.children.length > 0) {
        childArr = childArr.concat(this.getChildren(c.children))
      }
    })
    return childArr
  } 
  handleContextClose = () => {
    this.setState({
      contextAnchorEl: null,
      contextData: null,
      contextOpen: false,
    });
  };
  handleSetStart = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.changeTreeStart &&
          this.state.contextData &&
          this.props.changeTreeStart(this.state.contextData.data);
      }
    );
  };
  handleResetStart = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.changeTreeStart && this.props.changeTreeStart(null);
      }
    );
  };
  handleAddTaxonomy = () => {
    let d = {
      id: "-1",
      type: "taxonomy",
      name: "Taxonomy",
      icon: TAXONOMY_ICON_PLUS,
    };
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handleAdd &&
          this.props.handleAdd(
            d,
            this.state.contextData,
            this.state.contextAnchorEl
          );
      }
    );
  };
  handleAddTeam = () => {
    let d = { id: "-1", type: "team", name: "Team", icon: TEAM_ICON_PLUS };
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handleAdd &&
          this.props.handleAdd(
            d,
            this.state.contextData,
            this.state.contextAnchorEl
          );
      }
    );
  };
  handleAddTopic = () => {
    let d = { id: "-1", type: "topic", name: "Team", icon: TOPIC_ICON_PLUS };
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handleAdd &&
          this.props.handleAdd(
            d,
            this.state.contextData,
            this.state.contextAnchorEl
          );
      }
    );
  };
  handleCopy = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handleCopy &&
          this.props.handleCopy(this.state.contextData.data, false);
      }
    );
  };
  handleCopyChildren = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handleCopy &&
          this.props.handleCopy(this.state.contextData.data, true);
      }
    );
  };
  handlePaste = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.handlePaste &&
          this.props.handlePaste(this.state.contextData.data);
      }
    );
  };
  handleRemoveFromTree = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.removeFromTree &&
          this.props.removeFromTree(this.state.contextData.data);
      }
    );
  };
  handleRemoveChildren = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.removeChildren &&
          this.props.removeChildren(this.state.contextData.data);
      }
    );
  };
  handleUnlinkFromTree = () => {
    this.setState(
      {
        contextOpen: false,
      },
      () => {
        this.props.unlinkFromTree &&
          this.props.unlinkFromTree(this.state.contextData);
      }
    );
  };

  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <div id="tooltip" />
        <div style={{ width: this.props.width, display: "flex" }}>
          {this.props.organization !== null && (
            <div
              style={{
                display: "flex",
                margin: theme.spacing(1),
                marginLeft: theme.spacing(2),
              }}
            >
              <div style={{ marginTop: theme.spacing(0.65) }}>
                <SvgIcon focusable="false">
                  <path d={ORGANIZATION_ICON} />
                </SvgIcon>
              </div>
              <div
                style={{
                  marginLeft: theme.spacing(1),
                  marginTop: theme.spacing(0.25),
                }}
              >
                <span>
                  <Typography variant="h6" gutterBottom={true}>
                    {this.props.organization.organizationName}
                  </Typography>
                </span>
              </div>
            </div>
          )}
          <div id="draggableTools" className={classes.draggableTools}>
            <div
              id="draggable-taxonomy"
              className={classes.draggable}
              draggable={"true"}
              onDragStart={this.props.dragStart}
              onDragEnd={this.props.dragEnd}
              d={
                '{"id":"-1", "type":"taxonomy","name":"Taxonomy", "icon":"' +
                TAXONOMY_ICON_PLUS +
                '"}'
              }
            >
              <SvgIcon focusable="true">
                <path
                  d={TAXONOMY_ICON_PLUS}
                  fill={this.state.taxonomyColourTheme}
                />
              </SvgIcon>
            </div>
            <div
              id="draggable-team"
              className={classes.draggable}
              draggable={"true"}
              onDragStart={this.props.dragStart}
              onDragEnd={this.props.dragEnd}
              d={
                '{"id":"-1", "type":"team", "name":"Team","icon":"' +
                TEAM_ICON_PLUS +
                '"}'
              }
            >
              <SvgIcon>
                <path d={TEAM_ICON_PLUS} fill={this.state.teamColourTheme} />
              </SvgIcon>
            </div>
            <div
              id="draggable-topic"
              className={classes.draggable}
              draggable={"true"}
              onDragStart={this.props.dragStart}
              onDragEnd={this.props.dragEnd}
              d={
                '{"id":"-1", "type":"topic", "name":"Topic","icon":"' +
                TOPIC_ICON_PLUS +
                '"}'
              }
            >
              <SvgIcon id="tree-component-topic-icon">
                <path d={TOPIC_ICON_PLUS} fill={this.state.topicColourTheme} />
              </SvgIcon>
            </div>
          </div>
        </div>
        <div id="chart" draggable={"true"} onDragOver={this.props.dragOver} />
        <Menu
          id="context-menu"
          anchorEl={this.state.contextAnchorEl}
          keepMounted
          open={this.state.contextOpen}
          onClose={this.handleContextClose}
          onEntered={this.preventContextMenuOnModal}
        >
          {this.state.contextData && (
            <div className={classes.contextMenuTitleWrapper}>
              <div>
                <SvgIcon>
                  <path
                    d={
                      this.state.contextData.data.type === TAXONOMY
                        ? TAXONOMY_ICON
                        : this.state.contextData.data.type === TEAM
                          ? TEAM_ICON
                          : TOPIC_ICON
                    }
                    fill={
                      this.state.contextData.data.type === TAXONOMY
                        ? this.state.taxonomyColourTheme
                        : this.state.contextData.data.type === TEAM
                          ? this.state.teamColourTheme
                          : this.state.topicColourTheme
                    }
                  />
                </SvgIcon>
              </div>
              <div className={classes.contextMenuTitle}>
                {this.state.contextData.data.name}
              </div>
            </div>
          )}
          {this.state.contextData !== null && (
            <>
              {this.state.contextData.data.type === TAXONOMY ? (
                this.props.treeStart !== null ? (
                  this.props.treeStart.id === this.state.contextData.data.id ? (
                    <MenuItem onClick={this.handleResetStart}>
                      Show All
                    </MenuItem>
                  ) : (
                    <MenuItem onClick={this.handleSetStart}>
                      Start Tree From Here
                    </MenuItem>
                  )
                ) : (
                  this.state.contextData.data.parentList.length > 0 && (
                    <MenuItem onClick={this.handleSetStart}>
                      Start Tree From Here
                    </MenuItem>
                  )
                )
              ) : 
                (this.state.contextData.data.type === TOPIC && !this.state.contextData.data.reportTopic) || (this.state.contextData.data.type === TEAM) && (
                  <MenuItem onClick={this.handleRemoveFromTree}>
                    Remove ALL from Tree
                  </MenuItem>
              )}
              {(this.state.contextData.data.type === TAXONOMY &&
                this.state.contextData.data.parentList.length > 0 && !this.state.contextData.data.isReports) ||
                (this.state.contextData.data.type === TOPIC && !this.state.contextData.data.reportTopic) || (this.state.contextData.data.type === TEAM) &&  (
                <MenuItem onClick={this.handleUnlinkFromTree}>
                  Remove from Tree
                </MenuItem>
              )}
              {(this.state.contextData.data.type === TAXONOMY && !this.state.contextData.data.reportTopic )&& (
                  <MenuItem
                    disabled={this.state.contextData.data.children.length === 0}
                    onClick={this.handleRemoveChildren}
                  >
                    Remove Children
                  </MenuItem>
              )}
              {this.state.contextData.data.type === TAXONOMY && (
                <>
                  <MenuItem onClick={this.handleAddTaxonomy}>
                    Add Taxonomy Node
                  </MenuItem>
                  <MenuItem onClick={this.handleAddTeam}>Add Team</MenuItem>
                  <MenuItem onClick={this.handleAddTopic}>Add Topic</MenuItem>
                  </>
              )}
            </>
          )}
          {this.state.contextData &&
            this.state.contextData.data.type === TAXONOMY && (
              <>
                <MenuItem onClick={this.handleCopy}>Copy</MenuItem>
                <MenuItem onClick={this.handleCopyChildren}>
                  Copy Children Only
                </MenuItem>
                <MenuItem
                  disabled={this.props.copiedData === null}
                  onClick={this.handlePaste}
                >
                  Paste
                </MenuItem>
              </>
            )}
        </Menu>
      </>
    );
  }
}

export default withTheme(withStyles(styles)(TreeComponent));
